/****************************************************************IMPORTS*/
/****************************************NPM MODULES*/
import { FC } from "react";
/****************************************************/

/*****************************************INTERFACES*/
import { ILaunch } from "../interfaces";
/****************************************************/
/************************************************************************/


/************************************************************COORDINATES*/
export const Launch: FC<ILaunch> = ({ setLaunch }) => {
    /*****************************************RETURN TSX*/
    return (
        <button className="launch" onClick={(): void => setLaunch(true)}>Lancer simulation</button>
    );
    /****************************************************/
};
/************************************************************************/